<template>
  <div class="report-detail">
    <div class="back">
      <a-button type="primary" @click="goBack"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
      <a-button type="primary" style="margin-left: 10px;">下载报告</a-button>
    </div>

    <div class="detail-content">
      <div class="info-section">
        <div class="section-title">测试车辆信息</div>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">车辆编码</span>
            <span class="value">{{ reportDetail.licenceNo || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">测试/运营主体</span>
            <span class="value">{{ reportDetail.deptName || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">车辆类型</span>
            <span class="value">{{ reportDetail.vehicleType || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">车辆识别码</span>
            <span class="value">{{ reportDetail.vehicleVin || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">测试时间</span>
            <span class="value">{{ reportDetail.testTime || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">报告日期</span>
            <span class="value">{{ reportDetail.reportDate || '-' }}</span>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="section-title">行驶里程信息</div>
        <a-table :columns="mileageColumns" :data-source="mileageData" size="middle" :pagination="false" :scroll="{ x: 'auto' }">
        </a-table>
      </div>

      <div class="info-section">
        <div class="section-title">任务统计</div>
        <a-table :columns="taskColumns" :data-source="taskData" size="middle" :pagination="false" :scroll="{ x: 'auto' }">
        </a-table>
      </div>

      <div class="info-section">
        <div class="section-title">系统告警统计</div>
        <a-table :columns="alarmColumns" :data-source="alarmData" size="middle" :pagination="false" :scroll="{ x: 'auto' }">
        </a-table>
      </div>

      <div class="info-section">
        <div class="section-title">交通事故与违规统计</div>
        <a-table :columns="accidentColumns" :data-source="accidentData" size="middle" :pagination="false" :scroll="{ x: 'auto' }">
        </a-table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const reportDetail = ref(JSON.parse(sessionStorage.getItem('testReportDetail')) || {});

const statistics = computed(() => reportDetail.value.statistics || {});

const mileageColumns = [
  {
    title: "统计项",
    dataIndex: "item",
    key: "item",
    width: 200,
    align: "center"
  },
  {
    title: "数值",
    dataIndex: "value",
    key: "value",
    width: 200,
    align: "center"
  }
];

const mileageData = computed(() => [
  {
    key: 1,
    item: "总行驶里程",
    value: statistics.value.totalMileage ? `${statistics.value.totalMileage} km` : '-'
  },
  {
    key: 2,
    item: "自动驾驶行驶里程",
    value: statistics.value.autoDriveMileage ? `${statistics.value.autoDriveMileage} km` : '-'
  },
  {
    key: 3,
    item: "自动驾驶总时长",
    value: statistics.value.autoDriveDuration ? formatDuration(statistics.value.autoDriveDuration) : '-'
  },
  {
    key: 4,
    item: "自动驾驶占比",
    value: statistics.value.autoDriveRatio !== undefined && statistics.value.autoDriveRatio !== null ? `${statistics.value.autoDriveRatio}%` : '-'
  }
]);

const taskColumns = [
  {
    title: "统计项",
    dataIndex: "item",
    key: "item",
    width: 200,
    align: "center"
  },
  {
    title: "数值",
    dataIndex: "value",
    key: "value",
    width: 200,
    align: "center"
  }
];

const taskData = computed(() => [
  {
    key: 1,
    item: "执行任务总次数",
    value: statistics.value.taskCount ? `${statistics.value.taskCount} 次` : '-'
  },
  {
    key: 2,
    item: "覆盖路线数",
    value: statistics.value.routeCount ? `${statistics.value.routeCount} 条` : '-'
  }
]);

const alarmColumns = [
  {
    title: "统计项",
    dataIndex: "item",
    key: "item",
    width: 200,
    align: "center"
  },
  {
    title: "数值",
    dataIndex: "value",
    key: "value",
    width: 200,
    align: "center"
  }
];

const alarmData = computed(() => [
  {
    key: 1,
    item: "系统告警总次数",
    value: statistics.value.alarmTotal ? `${statistics.value.alarmTotal} 次` : '-'
  },
  {
    key: 2,
    item: "超速",
    value: statistics.value.speedAlarm ? `${statistics.value.speedAlarm} 次` : '-'
  },
  {
    key: 3,
    item: "超区域行驶",
    value: statistics.value.outOfAreaAlarm ? `${statistics.value.outOfAreaAlarm} 次` : '-'
  },
  {
    key: 4,
    item: "超时段行驶",
    value: statistics.value.outOfTimeAlarm ? `${statistics.value.outOfTimeAlarm} 次` : '-'
  },
  {
    key: 5,
    item: "感知告警",
    value: statistics.value.perceptionAlarm ? `${statistics.value.perceptionAlarm} 次` : '-'
  }
]);

const accidentColumns = [
  {
    title: "统计项",
    dataIndex: "item",
    key: "item",
    width: 200,
    align: "center"
  },
  {
    title: "数值",
    dataIndex: "value",
    key: "value",
    width: 200,
    align: "center"
  }
];

const accidentData = computed(() => [
  {
    key: 1,
    item: "交通事故次数",
    value: statistics.value.accidentCount ? `${statistics.value.accidentCount} 次` : '-'
  },
  {
    key: 2,
    item: "交通违规次数",
    value: statistics.value.violationCount ? `${statistics.value.violationCount} 次` : '-'
  }
]);

const goBack = () => {
  router.push('/report/testing');
};

const formatDuration = (minutes) => {
  if (!minutes) return '-';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours > 0) {
    return `${hours}小时${mins}分钟`;
  }
  return `${mins}分钟`;
};
</script>

<style lang="less" scoped>
.report-detail {
  padding: 20px 160px;
  background-color: #ffffff;
  min-height: calc(100vh - 70px - 57px);
}

.back {
  position: fixed;
  top: 93px;
  right: 50px;
  z-index: 20;
}

.detail-content {
  background: #F7F8FA;
  border-radius: 8px;
  padding: 20px;
}

.info-section {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #0A212E;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #E1E7EF;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;

  .label {
    font-size: 14px;
    color: #68767E;
    margin-bottom: 8px;
  }

  .value {
    font-size: 14px;
    color: #0A212E;
    font-weight: 500;
  }
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #0A212E;
  background-color: #EFEFF5;
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}
</style>